import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { request } from '@core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@shared/types/base-query';
import type { TApiResponse } from '../../../shared/types';
import type { TSubmissionWithQuestion } from '@src/shared/types/submission-with-question';

type TApplicationQuery = {
  q?: string;
  program: string | number;
  submission?: string | number;
  status?: string;
  exclude_status?: string[];
} & TBaseQuery;

export const getSubmissionsWithQuestions = async (options: {
  query: TApplicationQuery;
}): Promise<TApiResponse<TSubmissionWithQuestion>> => {
  const { program, ...restQuery } = options.query;
  return request({
    url: `programs/${program}/submissions/`,
    params: restQuery,
  });
};

export const useGetSubmissionsWithQuestions = (
  query: TApplicationQuery,
  options?: Partial<UseQueryOptions<TApiResponse<TSubmissionWithQuestion>>>
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.getSubmissionQuestions, { query }],
    queryFn: async () => await getSubmissionsWithQuestions({ query }),
    ...options,
  });
};
